import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import CustomField from "../../../../model/customField/CustomField";
import EditCustomFieldForm from "../form/edit/EditCustomFieldForm";


interface IComponentProps {
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Custom field to edit.
	 */
	customField: CustomField;
	/**
	 * Update custom field.
	 * @param {CustomField} customField
	 * @param {void} onActionFinish
	 */
	updateCustomField: (customField: CustomField, onActionFinish: () => void) => void;
}

export default class EditCustomFieldModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Edit custom field"} fixedWidth>
				<EditCustomFieldForm customField={this.props.customField}
									 updateCustomField={this.props.updateCustomField}
									 onCancel={this.props.onCancel}/>
			</Modal>
		);
	}
}
